import { render, staticRenderFns } from "./QianchuanViolationWord.vue?vue&type=template&id=23e8c489&scoped=true"
import script from "./QianchuanViolationWord.vue?vue&type=script&lang=js"
export * from "./QianchuanViolationWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8c489",
  null
  
)

export default component.exports